module.exports = __webpack_public_path__ + "static/media/transactionModal.1c6a5652.svg";